import { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { Tooltip } from '@rossum/ui/material';

type FullTimestampTooltipProps = {
  createdAt: string;
  children: ReactNode;
};

// Visible labels omit seconds and the time zone, so versions saved within the
// same minute would look identical and the zone is ambiguous. The full
// timestamp is available on hover.
export const FullTimestampTooltip = ({
  createdAt,
  children,
}: FullTimestampTooltipProps) => {
  const intl = useIntl();

  return (
    <Tooltip
      title={intl.formatDate(new Date(createdAt), {
        dateStyle: 'full',
        timeStyle: 'long',
      })}
    >
      <span>{children}</span>
    </Tooltip>
  );
};
